import * as Actions from '../tasks.actions';
import * as AccActions from '../../accreditation.actions';
import { IDS } from '../tasks-action-id.constants'
import { TYPES } from "../tasks-action-type.constants";
import {TAB_ENABLE, TAB_SELECT} from "../../../../common/tabs/tabs.constants";
import {IDS as SECTION_IDS} from "../../requirements-assessment/requirements-assessment-action-id.constants";
import {GRID_FILTER} from "../../../../common/grid/grid.constants";
import watch from "redux-watch";
import get from "lodash/get";
import {fetchTaskDetails} from "../tasks.actions";
import {TYPES as ACC_TYPES} from "../../accreditation-action-type.constants";
import I18N from "../../../../common/utils/util.i18n";

/**
 * Creates a new AccTasksController.
 * @class
 */
class AccTasksController {
    constructor($ngRedux,
                $state,
                $stateParams,
                $uiRouterGlobals,
                $transitions,
                $scope,
                $rootScope,
                $filter,
                $timeout,
                $mdDialog,
                $location,
                Notifier,
                AuthService
                ) {

        this.$ngRedux   = $ngRedux;
        this.$state     = $state;
        this.$stateParams = $stateParams;
        this.$uiRouterGlobals = $uiRouterGlobals;
        this.$transitions = $transitions;
        this.$scope     = $scope;
        this.$rootScope = $rootScope;
        this.$filter    = $filter;
        this.$timeout   = $timeout;
        this.$mdDialog  = $mdDialog;
        this.$location  = $location;
        this.Notifier   = Notifier;
        this.AuthService = AuthService;
    }

    $onInit() {
        // this.isPublic = this.$state.$current.name.split('.')[0] === 'public';
        this.identifier = IDS.accTasks;
        this.gridIdentifier = IDS.accTasksGrid;
        this.unsubscribe = this.$ngRedux.connect(state => {
            const accTasks = state.accreditation[this.identifier];
            const accTasksGrid = accTasks[this.gridIdentifier];
            const user = state.app.user;

            return {
                siteLocationUuid:   accTasksGrid?.slo_uuid,
                selectedYear:       accTasksGrid?.selectedYear,
                // tasks:              accTasksGrid?.items,
                userType:           user.typeCode,
                userUuid:           user.uuid,
                isManager:          user.isManager,
                taskStatuses:       accTasks.taskStatuses,
                taskTypes:          accTasks.taskTypes,
                firstDocType:       state.accreditation.common.documentTypes[0].value
            }
        }, {
            ...AccActions,
            ...Actions
        })(this);

        const taskId = this.$uiRouterGlobals?.params?.task_id;

        if (taskId) {
            const ctrl = this;
            this.$timeout(() => {
                this.fetchTaskDetails(taskId).then(item => {
                    ctrl.onSelect({item});
                });
            },200);
        }

        this.localizeTasksGridFilter(this.taskStatuses, this.taskTypes);

    }

    onSelect({item}){
        switch(item.uta_type) {

            case 'utimas': // improvement action step
                this.fetchTaskDetails(item.par_id, 'utimca').then(data => {
                    data.statusName = I18N.translate(`ACCREDITATION.TASKS.STATUS.${data.status_code.toUpperCase()}`, data.status_code);
                    this.$ngRedux.dispatch({
                        type: TYPES.IMPROVEMENT_ACTION_REFRESH,
                        id: IDS.accTasks,
                        data,
                    });
                });
            case 'utrcdr': // document revision
            case 'utrcer': // evidence review
                this.$ngRedux.dispatch({
                    type:   TYPES.TASK_DETAILS_REFRESH,
                    id:     IDS.accTasks,
                    data:  {
                        ...item,
                        comment: item.status_code === 'sub' ? item.closing_comment : null,
                    },
                    firstDocType: this.firstDocType,
                });
                this.$ngRedux.dispatch({
                    type: TAB_ENABLE,
                    id: IDS.app_accreditation_tasks,
                    state: IDS.app_accreditation_tasks_details,
                });
                this.$timeout(() => {
                    this.$ngRedux.dispatch({
                        type: TAB_SELECT,
                        id: IDS.app_accreditation_tasks,
                        state: IDS.app_accreditation_tasks_details,
                        stateParams: {
                            task_id: item.uta_id
                        },
                    });
                    // if is Evidence review or Document revision or Improvement step with evidence
                    if(item.ard_id) {
                        setTimeout(() => {
                            this.$ngRedux.dispatch({
                                type: GRID_FILTER,
                                id: this.identifier,
                                path: IDS.rcoEvidenceGroupDocumentsGrid,
                                filter: {
                                    identifier:     this.identifier,
                                    scheme_code:    item.framework_code,
                                    evidence_group: item.ard_id,
                                    requirement:    item.requirements[0].ase_id,
                                    fiscal_year:    item.fiscal_year,
                                    slo_uuid:       item.location_uuid,
                                }
                            });
                        }, 200);
                    }
                });
            break;

            case 'utrcau': // audit
                let newState;
                if (this.$uiRouterGlobals?.params?.requirement_id)
                    newState = SECTION_IDS.app_accreditation_scheme_requirements_assessment_evidence_groups;
                else
                    switch(item.requirement_level) {
                        case 2: newState = SECTION_IDS.app_accreditation_scheme_requirements_assessment_dashboard; break;
                        case 3: newState = SECTION_IDS.app_accreditation_scheme_requirements_assessment_evidence_groups; break;
                    }

                const itemCode =    item.framework_code.toLowerCase();
                const requirement = this.$uiRouterGlobals?.params?.requirement_id || item.requirements[0]?.ase_id;
                const year =        item.fiscal_year;
                const slo =         item.location_uuid;
                const hof =         item.hof_uuid;

                this.$ngRedux.dispatch({
                    type: ACC_TYPES.LOCATION_SEARCH_BAR_CHANGE,
                    accDashboardLocationYear: {
                        headOffice: hof,
                        siteLocation: slo,
                        year,
                    }
                });
                const ctrl = this;
                this.fetchFrameworkRequirementsTreeProgress(itemCode, slo, year).then(() => {
                    ctrl.selectRequirementById(requirement);
                    ctrl.$state.go(newState, {itemCode, requirement, year, hof, slo });
                });
            break;
        }
    }

    // onLinkDialog($event){
    //     const ctrl = this;
    //     this.dialog = {
    //         controller: ($scope, token) => {
    //             const loc = this.$location;
    //             $scope.url = [
    //                 loc.protocol(), '://',
    //                 loc.host(),
    //                 loc.port() !== '80' ? `:${loc.port()}` : '',
    //                 '/public/accreditation/task?token=', token
    //             ].join('');
    //             $scope.close = () => {
    //                 this.$mdDialog.cancel();
    //                 ctrl.dialog = undefined;
    //             }
    //         },
    //         template: require('./tasks-link-dialog.html'),
    //         parent: angular.element(document.body),
    //         locals: {
    //             token: $event.item.token
    //         },
    //     };
    //     this.dialog.controller.$inject = ['$scope', 'token'];
    //
    //     this.$mdDialog.show(this.dialog);
    // }

    $onDestroy() {
        this.unsubscribe();
        if (this.dialog)
            this.$mdDialog.hide(this.dialog);
    }
}

AccTasksController.$inject = [
    '$ngRedux',
    '$state',
    '$stateParams',
    '$uiRouterGlobals',
    '$transitions',
    '$scope',
    '$rootScope',
    '$filter',
    '$timeout',
    '$mdDialog',
    '$location',
    'Notifier',
    'AuthService',
]

export const accTasks = {
    bindings: {
    },
    controller: AccTasksController,
    template: `
        <acc-tasks-grid
            identifier="$ctrl.gridIdentifier"
            on-select="$ctrl.onSelect($event)">
        </acc-tasks-grid>
`,
}
